import { LoginResponseDTO } from "../DTO";

export class CfgEndpoint extends LoginResponseDTO{
  public Url: string;
  public Uname: string;
  public Pwd: string;
}



// WEBPACK FOOTER //
// ./src/app/door/cfgEndpoint.ts